import SectionHeading from "./SectionHeading";
import { chapters } from "@/mocks/home";

export default function ChapterGuide() {
  return (
    <section id="chapters" className="section-anchor bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="CHAPTER OVERVIEW"
          title="八个章节，串起关系推进的完整节奏"
          desc="把散落的情境条目放进时间线里，就能看清一段师生关系是如何从陌生、试探，一路走到重构与独立。"
        />

        <div className="mt-10 md:mt-14 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="hidden lg:grid grid-cols-12 gap-4 px-6 py-4 bg-background-200/60 font-label text-xs tracking-widest text-foreground-600">
            <span className="col-span-1">序号</span>
            <span className="col-span-3">章节标题</span>
            <span className="col-span-2">主题</span>
            <span className="col-span-3">核心场景</span>
            <span className="col-span-3">关系进展</span>
          </div>

          <ul>
            {chapters.map((item) => (
              <li
                key={item.no}
                className="grid grid-cols-1 lg:grid-cols-12 gap-2 lg:gap-4 px-5 md:px-6 py-4 border-t border-background-200 first:border-t-0 hover:bg-primary-100/40 transition-colors"
              >
                <span className="lg:col-span-1 font-heading text-lg font-bold text-primary-600">
                  {item.no}
                </span>
                <span className="lg:col-span-3 font-heading text-base font-bold text-foreground-950">
                  {item.title}
                </span>
                <span className="lg:col-span-2">
                  <span className="inline-block px-2.5 py-0.5 rounded-md bg-accent-100 text-accent-900 font-label text-xs">
                    {item.theme}
                  </span>
                </span>
                <span className="lg:col-span-3 inline-flex items-center gap-2 text-sm text-foreground-700">
                  <i className="ri-map-pin-2-line text-secondary-600" />
                  {item.scene}
                </span>
                <span className="lg:col-span-3 text-sm text-foreground-600">
                  {item.progress}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}